export default "__VITE_ASSET__DQrleu_w__"